import React from 'react';
import WorkflowTemplate from '../../components/WorkflowTemplate';
import { LEAD_STAGES } from 'models/Lead';

const WorkflowConfirmPage: React.FC = () => (
  <WorkflowTemplate page={LEAD_STAGES.CONFIRM} />
);

export default WorkflowConfirmPage;
